export interface NetworkNode {
  id: string;
  city: string;
  code: string;
  x: number;
  y: number;
  delay: number;
}

export const networkHub = { x: 310, y: 200 };

export const networkNodes: NetworkNode[] = [
  { id: 'mex', city: 'Mexico City', code: 'MX', x: 90, y: 150, delay: 0 },
  { id: 'bog', city: 'Bogotá', code: 'CO', x: 140, y: 255, delay: 1.4 },
  { id: 'sao', city: 'São Paulo', code: 'BR', x: 200, y: 345, delay: 2.6 },
  { id: 'lis', city: 'Lisbon', code: 'PT', x: 250, y: 75, delay: 0.7 },
  { id: 'ist', city: 'Istanbul', code: 'TR', x: 385, y: 70, delay: 3.1 },
  { id: 'lag', city: 'Lagos', code: 'NG', x: 300, y: 330, delay: 1.9 },
  { id: 'nai', city: 'Nairobi', code: 'KE', x: 410, y: 300, delay: 0.3 },
  { id: 'seo', city: 'Seoul', code: 'KR', x: 510, y: 90, delay: 2.2 },
  { id: 'man', city: 'Manila', code: 'PH', x: 530, y: 190, delay: 1.1 },
  { id: 'jak', city: 'Jakarta', code: 'ID', x: 495, y: 300, delay: 3.4 },
];

export const networkMesh: [string, string][] = [
  ['mex', 'bog'],
  ['bog', 'sao'],
  ['lis', 'ist'],
  ['lag', 'nai'],
  ['seo', 'man'],
  ['man', 'jak'],
  ['sao', 'lag'],
  ['nai', 'jak'],
  ['mex', 'lis'],
];
